module.exports = __webpack_public_path__ + "static/media/heart.f9691347.svg";